var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',_vm._g({staticClass:"white--text",staticStyle:{"text-transform":"none"},attrs:{"color":"bpbWarn","width":_vm.width,"height":_vm.height,"disabled":_vm.disabled,"loading":_vm.loading}},_vm.$listeners),[(_vm.icon)?_c('v-icon',{staticClass:"mr-2"},[_vm._v(_vm._s(_vm.icon))]):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }